import React, { createContext, useContext } from 'react';
import type { FlatList, StyleProp, ViewStyle } from 'react-native';
import type { ModuleEmptyStateProps } from '../../../shared/ui/ModuleEmptyState';
import type { PosHeaderSectionProps } from '../catalog/PosHeaderSection';
import type { ProductSearchRow } from '../../../catalog/domain-api';
import type { PosCatalogRow, PosPackageGridRow, PosStockSalePolicy } from '../../domain/posTypes';

export type PosCatalogContextValue = {
  productListRef: React.RefObject<FlatList<PosCatalogRow> | null>;
  products: PosCatalogRow[];
  refreshing: boolean;
  onRefresh: () => void;
  contentContainerStyle: StyleProp<ViewStyle>;
  listHeader?: PosHeaderSectionProps | null;
  listEmpty: ModuleEmptyStateProps;
  paginationDock: React.ReactNode;
  mobilePagination?: React.ReactNode;
  canEdit: boolean;
  onProductPress: (product: ProductSearchRow) => void;
  onPackagePress?: (row: PosPackageGridRow) => void;
  stockSalePolicy: PosStockSalePolicy;
  addedFlashProductId?: string | null;
  /** Rail: marcador en ficha (favorito). */
  onToggleProductFavorite?: (product: ProductSearchRow) => void;
  isProductFavorite?: (productId: string) => boolean;
  /** Rail: badges por fila (Combo / Oferta). */
  productBadges?: (productId: string) => { combo?: boolean; promo?: boolean };
  /** Desk: FlatList viewport height for viewport-aware page size. */
  onCatalogListViewportHeight?: (height: number) => void;
  /** Desk: ListHeader height (toolbar) for viewport-aware page size. */
  onCatalogListHeaderHeight?: (height: number) => void;
};

const PosCatalogContext = createContext<PosCatalogContextValue | null>(null);

export function PosCatalogProvider({
  value,
  children,
}: {
  value: PosCatalogContextValue;
  children: React.ReactNode;
}) {
  return <PosCatalogContext.Provider value={value}>{children}</PosCatalogContext.Provider>;
}

export function usePosCatalogContextOptional() {
  return useContext(PosCatalogContext);
}
